import { useState } from 'react'
import { CanteenCartItem, CanteenCartItemInput } from './types'
import { calculateCartTotal } from './cartHelpers'

export const useCartState = () => {
  const [cartItems, setCartItems] = useState<Record<string, CanteenCartItem>>({})

  const getCartItemReference = (cartItem: CanteenCartItemInput) => {
    // Current ref template is: I(itemId)-S(submenuId)-O[optionId1, optionId2]
    const { itemId, options, submenuId } = cartItem
    const optionIds =
      options != null && options.length > 0 ? options.map((option) => option.id).join('-') : ''
    const id = `I(${itemId})-S(${submenuId})${
      optionIds !== '' ? `-O(${options.map((option) => option.id).join('-')})` : ''
    }`
    return id
  }

  const updateCartItem = (updatedItem: CanteenCartItem) => {
    setCartItems((prev) => ({
      ...prev,
      [updatedItem.reference]: updatedItem,
    }))
  }

  const addCartItem = (cartItem: CanteenCartItemInput, arrivalTime: string) => {
    const itemReference = getCartItemReference(cartItem)
    const itemToAdd: CanteenCartItem = {
      ...cartItem,
      reference: getCartItemReference(cartItem),
      arrivalTime,
      qty: (cartItems[itemReference]?.qty ?? 0) + cartItem.qty,
    }
    setCartItems((prev) => ({
      ...prev,
      [itemReference]: itemToAdd,
    }))
  }

  const removeCartItem = (itemReference: string) => {
    setCartItems((prev) => {
      const newItems = { ...prev }
      delete newItems[itemReference]
      return newItems
    })
  }

  const emptyCart = () => {
    setCartItems({})
  }

  const cartItemsArray = Object.values(cartItems)
  const cartTotal = calculateCartTotal(cartItemsArray)
  const itemQuantity = cartItemsArray.reduce((rtn, item) => rtn + item.qty, 0)

  return {
    addCartItem,
    removeCartItem,
    updateCartItem,
    emptyCart,
    cartItems: cartItemsArray,
    cartTotal,
    itemQuantity,
  }
}
